module.exports = __webpack_public_path__ + "static/img/money-05.cae04b3.png";